import type { FC, ImgHTMLAttributes } from "react";
import React from "react";

import { createDisplayNameForMediaElement } from "../../utils/getDisplayName";
import { createTestIdForMediaElement } from "../../utils/getTestId";

import classes from "./MediaBlur.styl";

const BLUR_TEST_ID = createTestIdForMediaElement("blur");

interface IBlurProps extends Pick<ImgHTMLAttributes<HTMLImageElement>, "src"> {}

export const Blur: FC<IBlurProps> = ({ src }) => {
    return (
        <img
            className={classes.blur}
            src={src}
            alt=""
            aria-hidden
            data-tsid={BLUR_TEST_ID}
        />
    );
};

Blur.displayName = createDisplayNameForMediaElement("Blur");

export default Blur;
